import * as yup from "yup";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { HTTP_ENDPOINTS, QUERY_KEYS } from "../../consts/api";
import { http } from "../../services/HttpService";

const requestSchema = yup.object({
  cardId: yup.number().required(),
});

export function useDeleteCCMutation(options = {}) {
  const queryClient = useQueryClient();

  return useMutation(
    (dto) => {
      const req = requestSchema.validateSync(dto, {
        strict: true,
      });
      return http.delete(HTTP_ENDPOINTS.deleteCC(req.cardId));
    },
    {
      ...options,
      onSuccess: (...args) => {
        [
          QUERY_KEYS.client,
          QUERY_KEYS.clientCreditCards,
          QUERY_KEYS.stripe.paymentMethods,
        ].forEach((key) => {
          queryClient.invalidateQueries({
            queryKey: [key],
          });
        });

        options?.onSuccess?.(...args);
      },
    },
  );
}
